(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joy-complementary-products"] && !Shopify.designMode) return;
  try {
    
function loadJoyComplementarySection(sectionRoot) {
  var target = sectionRoot.querySelector(".joy-complementary-products");
  if (!target || !target.dataset.url) return;

  var request = new XMLHttpRequest();
  request.open("GET", target.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var loaded = container.querySelector(".section-joy-complementary-products .joy-complementary-products") || container.querySelector(".joy-complementary-products");
      if (loaded) {
        target.innerHTML = loaded.innerHTML;
      }
    }
  };
  request.send();
}

document.querySelectorAll(".section-joy-complementary-products").forEach(loadJoyComplementarySection);

document.addEventListener("shopify:section:load", function(event) {
  if (event.target && event.target.classList.contains("section-joy-complementary-products")) {
    loadJoyComplementarySection(event.target);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
function loadRelatedProductsSection(sectionRoot) {
  var productRecommendationsSection = sectionRoot.querySelector(".related-products");
  if (!productRecommendationsSection || !productRecommendationsSection.dataset.url) return;

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var loadedSection = container.querySelector(".section-related-products .related-products") || container.querySelector(".related-products");
      if (loadedSection) {
        productRecommendationsSection.innerHTML = loadedSection.innerHTML;
      }
    }
  };
  request.send();
}

document.querySelectorAll(".section-related-products").forEach(loadRelatedProductsSection);

document.addEventListener("shopify:section:load", function(event) {
  if (event.target && event.target.classList.contains("section-related-products")) {
    loadRelatedProductsSection(event.target);
  }
});

  } catch(e) { console.error(e); }
})();
})();
